import Vue from "vue";
import VueI18n from "vue-i18n";
import localeEn from "./locale-en.json";
import localeDe from "./locale-de.json";
import localeRu from "./locale-ru.json";
import localeEs from "./locale-es.json";
import themeLocaleEn from "../../temp/i18n/locale-en.json";
import themeLocaleDe from "../../temp/i18n/locale-de.json";
import {resolveDeviceContext} from "../util/deviceContext";
import {pluralizationRules} from "./pluralization";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: resolveDeviceContext().lang,
    fallbackLocale: "en",
    // Russian needs three plural forms chosen by the last digits; the built-in rule only
    // distinguishes one from many. See i18n/pluralization.
    pluralizationRules,
    messages: {
        de: {
            ...localeDe,
            ...themeLocaleDe // theme wordings are overwriting the default wordings...
        },
        en: {
            ...localeEn,
            ...themeLocaleEn
        },
        ru: {
            ...localeRu
        },
        es: {
            ...localeEs
        }
    }
});

export default i18n;
